import moment from "moment";

export const getYearOptions = () => {
    const currentYear = moment().year(); // Get the current year
    const years = [];

    // Generate years from 5 years ago to the current year
    for (let i = currentYear - 5; i <= currentYear; i++) {
        years.push(i);
    }

    return years;
};